import { Component, OnInit, Input } from "@angular/core";
import {
  MatTableDataSource,
  MatSort,
  MatPaginator,
  Sort,
} from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/data.service";
import { ToastService } from "ng-uikit-pro-standard";
import { FormBuilder } from "@angular/forms";
@Component({
  selector: "app-validationrulelist",
  templateUrl: "./validationrulelist.component.html",
  styleUrls: ["./validationrulelist.component.scss"],
})
export class ValidationrulelistComponent implements OnInit {
  @Input() metaobjectid: string;
  @Input() objectname: string;
  @Input() parentobjectid: string;
  @Input() parentobjectname: string;
  @Input() embeddedobject: boolean;
  profileId = "";
  metaobjectId = "";
  objectName = "";
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject: boolean;
  matSort: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  refineLayoutList = [];

  sorting = {
    fieldName: "displayname",
    order: "ASC",
  };
  validationrules: any;

  sortData(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === "") {
      //default sorting
      this.sorting.fieldName = "createddate";
      this.sorting.order = "ASC";
    } else {
      const isAsc = sort.direction.toLocaleUpperCase() === "ASC";
      this.sorting.fieldName = sort.active;
      if (isAsc) {
        this.sorting.order = "ASC";
      } else {
        this.sorting.order = "DESC";
      }
    }
  }

  displayedColumns: string[] = [
    "id",
    "name",
    "errorlocation",
    "modifiedby",
    "modifieddate",
    "active",
  ];
  
  dataSource = new MatTableDataSource();
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.metaobjectId = this.metaobjectid;
    this.objectName = this.objectname;
    this.parentobjectId = this.parentobjectid;
    this.parentobjectName = this.parentobjectname;
    this.embeddedObject = this.embeddedobject;
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
    this.profileId = userDetail.profileid;

    this.getValidationrule();
  }

  newValidationRule() {
    this.router.navigateByUrl(
      "/home/validationrule/new/" +
        this.metaobjectId +
        "/" +
        this.objectName +
        "/" +
        this.profileId
    );
  }

  getValidationrule() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    this.isLoading = true;
    this.dataService
      .getValidationRule(organizationid,this.metaobjectId, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            // this.router.navigate(['home/globalaction'])
            // window.location.reload();
            this.validationrules = res.data.validationrule;
            this.dataSource.data = this.validationrules;

            // if (this.validationrules != null) {
            //   this.dataSource = this.validationrules.map((validationrule) => ({
            //     id: validationrule.id,
            //     labelname: validationrule.name,
            //     name: validationrule.name,
            //     // folder: validationrule.folderid,
            //     createdby: validationrule.createdby,
            //     createddate: validationrule.createddate,
            //     // actions: dashboard.name,
            //   }));
            // }
            this.isLoading = false;
          } else {
            console.log("error in getting data");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService
      .deleteValidationRule(organizationid,id,this.objectname, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            window.location.reload();

            this.isLoading = false;

            this.showSuccess(res.message);
          } else {
            console.log("Failed to delete!");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }
}
